// extracted by mini-css-extract-plugin
export default {"root":"formControl_root__+oE9Z","fullWidth":"formControl_fullWidth__MbsYt"};